import { ColorCollectionsDraftApi, useAPIQuery } from "melco-shared-logic";

export const useColorCollectionReferences = (colorCollectionId: string) => {
  return useAPIQuery(
    ColorCollectionsDraftApi,
    ["colorCollectionReferences", colorCollectionId],
    async (api) => api.colorCollectionsReferences({ id: colorCollectionId })
  );
};
